import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Sparkles, Flame } from "lucide-react";

export default function FoundingCounter({ compact = false, "data-testid": testId = "founding-counter" }) {
  const [d, setD] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = () => api.get("/launch/founding-count")
      .then(r => { if (!cancelled) setD(r.data); })
      .catch(() => {});
    load();
    const id = setInterval(load, 30000); // refresh every 30s
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  if (!d) return null;
  const filling = d.pct_filled >= 80;
  const isFull = d.is_full;

  if (compact) {
    return (
      <span data-testid={testId} className="inline-flex items-center gap-1.5 text-xs font-semibold text-[var(--ff-primary)]">
        <Sparkles size={12}/>
        {isFull ? "Founding closed" : <>Founding · <span className="tabular-nums">{d.remaining}</span> spots left</>}
      </span>
    );
  }

  return (
    <div data-testid={testId} className="card-flat p-5 max-w-md mx-auto">
      <div className="flex items-center justify-between">
        <p className="overline">Founding Members</p>
        {filling && !isFull && (
          <span className="inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wider text-red-700">
            <Flame size={12}/> Filling up
          </span>
        )}
      </div>
      <div className="mt-3 flex items-baseline gap-2">
        <span className="font-display text-4xl tabular-nums" data-testid="founding-count-num">{d.count}</span>
        <span className="text-[var(--ff-text-muted)] tabular-nums">/ {d.cap}</span>
      </div>
      <div className="mt-3 h-2 bg-[var(--ff-muted)] rounded-full overflow-hidden">
        <div className="h-full bg-gradient-to-r from-[var(--ff-primary)] to-[var(--ff-citrus)] transition-all duration-700"
             style={{ width: `${Math.min(100, d.pct_filled)}%` }}/>
      </div>
      <p className="text-xs text-[var(--ff-text-muted)] mt-2" data-testid="founding-counter-msg">
        {isFull
          ? "All founding spots claimed. Standard pricing applies."
          : d.pct_filled >= 80
            ? <>Only <strong className="text-red-700 tabular-nums">{d.remaining}</strong> founding spots remaining — lock yours in before they're gone.</>
            : <><strong className="tabular-nums">{d.remaining}</strong> spots left · Premium signups during presale lock in founding status forever.</>
        }
      </p>
    </div>
  );
}
